import dialog from '../../core/dialog';
import databoard from '../../core/databoard';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('../../info').get(name);

class ServiceAreaAfterSalesAction {
    constructor({ feature, layer, currentMap, name }) {
        const turnOn = () => {
            const control = LayerControls('ServiceAreaAfterSales');
            const controlOptions = control._getServiceAreaOptions();
            const drawn = control.hasServiceAreaForStore(feature.properties.Id);

            if (drawn.hasAny) {
                controlOptions.showRadiusReal = drawn.hasReal;
                controlOptions.showRadiusTheoretical = drawn.hasTheoretical;

                const customStyle = control.getStoreCustomStyle(feature.properties.Id);
                if (customStyle) {
                    controlOptions.color = customStyle.color;
                    controlOptions.opacity = customStyle.opacity;
                    controlOptions.weight = customStyle.weight;
                }
            }

            dialog.serviceAreaStyle('serviceArea', {
                options: controlOptions,
                change: (e, onClose) => {
                    control.removeStore(feature.properties.Id);
                    control.loadForStore(feature.properties.Id, e);
                    control.check(true, false);

                    const nameTypeArea = (e.showRadiusReal && e.showRadiusTheoretical) ? 'Área Real + Área Potencial'
                        : e.showRadiusReal ? 'Área Real' : 'Área Potencial';
                    $('.store-influence-subtitle').text(nameTypeArea);
                    $('.store-influence-btn-edit').text('Editar');
                    $('.store-influence-btn-delete').show();

                    LayerControls(name).createDashboardServiceArea(feature, {
                        hasReal: e.showRadiusReal,
                        hasTheoretical: e.showRadiusTheoretical,
                        hasAny: e.showRadiusReal || e.showRadiusTheoretical
                    });

                    onClose();
                },
                onStyle: () => {},
                onDelete: (onClose) => {
                    control.removeStore(feature.properties.Id);

                    databoard.reset();
                    databoard.hide();
                    LayerInfo('ResumeAfterSales').updateBoardInfluenceArea(feature);
                    onClose();
                }
            });
        };

        return {
            layer,
            check: false,
            map: currentMap,
            icon: 'icon_bubble_tradearea',
            title: 'Área de Influência',
            off: turnOn,
            on: turnOn
        };
    }
}

export default ServiceAreaAfterSalesAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/ServiceAreaAfterSalesAction.js